import {
  Box,
  Heading,
  Image,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect } from "react";
import Aos from "aos";
import styles from "./Css/Tools.module.css";
import techStackData from "../techData.json";


export default function Tools() {
  useEffect(() => {
    Aos.init({
      duration: 500,
      anchorPlacement: "center-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  });

  return (
    <Box
      className={styles.techBody}
      borderLeft="20px solid royalBlue"
      mt="50px"
     
    >
      <Heading
        id="techstack"
        fontSize={{ base: "100px", sm: "160px", md: "250px" }}
        color={useColorModeValue("gray.300", "gray.600")}
        className={styles.techstackHeading}
        fontFamily="'Playfair Display', serif"
      >
        Skills
      </Heading>
      {/* with images */}
      <SimpleGrid
        columns={{ base: 2, sm: 3, md: 4,lg:5 }}
        spacing="5px"
        m="auto"
        mt={{ sm: "-120px", md: "-160px" }}
        className={styles.techStackIcon}
      >
        {techStackData.map((ele) => (
          <Box data-aos="flip-up" data-aos-easing="ease-in-out" key={ele.id}>
            <Image src={ele.techImage} alt={ele.techName} />
            <Heading fontFamily="sans-serif" mt="10px" as="h1" fontSize="20px">
              {ele.techName}
            </Heading>
          </Box>
        ))}
        {/* <Image src="https://www.w3.org/html/logo/downloads/HTML5_Badge_512.png" bg="red" w="200px" h="200px" alt=""/> */}
      </SimpleGrid>

      {/* with icons */}
      {/* <Box maxW="1048px" m="auto">
        <SimpleGrid
          columns={{ base: 2, sm: 3, md: 5 }}
          spacing="5px"
          m="auto"
          className={styles.techStackIcon}
        >
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <AiFillHtml5 />
          </Box>

          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <IoLogoCss3 />
          </Box>

          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <IoLogoJavascript />
          </Box>

          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <DiReact />
          </Box>
          <Box
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
          >
            <SiMongodb />
          </Box>
          <Box
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
          >
            <DiNodejsSmall />
          </Box>
          <Box
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
          >
            <SiExpress />
          </Box>
          <Box
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
          >
            <SiRedux />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <SiChakraui />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <FiFigma />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <VscJson />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <SiTypescript />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <SiPostman />
          </Box>
          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <DiGit />
          </Box>

          <Box
            data-aos="zoom-out"
            data-aos-easing="ease-in-out"
          >
            <SiBootstrap />
          </Box>
        </SimpleGrid>
      </Box> */}
    </Box>
  );
}
